import script from "./web-main.vue?vue&type=script&setup=true&lang=js"
export * from "./web-main.vue?vue&type=script&setup=true&lang=js"

import "./web-main.vue?vue&type=style&index=0&id=64b5aeb6&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/qd-brcashy-h5-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64b5aeb6"]])

export default __exports__